// extracted by mini-css-extract-plugin
module.exports = {"ImgHolder":"MainInfoLoader_ImgHolder__2N0eh","anim":"MainInfoLoader_anim__1s_5n","InfoBox":"MainInfoLoader_InfoBox__zVREO"};